/**
 * Default max number of retries available due to fetch throwing TypeError
 *  most often due to network error
 */
export const requestMaxRetryDefault: number = 3;
